import React, { useState } from "react";
import logo from "../../assets/images/he1.svg";
import logohover from "../../assets/images/he2hover.svg";
import backIcon from "../../assets/images/back.svg";
import { Link, useNavigate } from "react-router-dom";
import { scrollToId } from "../../utils/Helper";

const Header = ({ isBackEnable }) => {
  let navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const redirectToSection = (event, id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
  };
  return (
    <header className="header">
      <div className="container">
        <div className="header-inner">
          <div className="col-left">
            <Link className="logo" to="/">
              <img src={logo} alt="Happy Ending" className="happy-logo" />
              <img src={logohover} alt="Happy Ending" className="happy-logo2" />
              Happy Ending
            </Link>
          </div>
          <nav className="navbar navbar-expand-lg">
            {/* Navbar Toggler */}
            <button
              className="navbar-toggler"
              type="button"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Navbar Links (Show/Hide based on State) */}
            <div
              className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}
            >
              <ul className="navbar-nav">
                <li className="nav-item dropdown">
                  <a
                    className="nav-link"
                    onClick={(e) => redirectToSection(e, "streamline")}
                    // id="productDropdown"
                    // role="button"
                    // data-bs-toggle="dropdown"
                  >
                    Product
                  </a>
                  {/* <ul
                    className="dropdown-menu"
                    aria-labelledby="productDropdown"
                  >
                    <li>
                      <Link className="dropdown-item" to="/product1">
                        Product 1
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/product2">
                        Product 2
                      </Link>
                    </li>
                  </ul> */}
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    onClick={(e) => redirectToSection(e, "pricing")}
                  >
                    Pricing
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    onClick={(e) => redirectToSection(e, "benifits")}
                  >
                    Benefit
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    onClick={(e) => redirectToSection(e, "faqs")}
                  >
                    FAQs
                  </a>
                </li>

                <li className="nav-item dropdown">
                  <Link className="nav-link" to={"/bloglist"}>
                    Blogs
                  </Link>
                </li>

                <li className="nav-item nav-item-mobile">
                  <a
                    className="nav-link"
                    href="https://app.happyending.ai/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Login
                  </a>
                </li>
                <li className="nav-item nav-item-mobile">
                  <Link className="nav-link" to="/faqs">
                    Get Demo
                  </Link>
                </li>
              </ul>
            </div>
          </nav>

          <div className="col-right">
            <a
              className="nav-link"
              href="https://app.happyending.ai/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Login
            </a>
            {isBackEnable && (
              <Link to="/" className="me-3 back-btn">
                {" "}
                <img src={backIcon} alt="Back" /> Back
              </Link>
            )}
            <a
              href="#"
              // onClick={(e) => redirectToSection(e, "wishlist")}
              className="btn secondary"
            >
              Get Demo
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
